/* @ngInject */
const listCtrl = (
  $scope,
  storageHandler,
  // $$list
) => {
  $scope.wagons = storageHandler.get('wagons-list-1')
}

export default listCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/list/list.controller.js